import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/services/user.service';

@Component({
  selector: 'dialog-user-msg',
  templateUrl: './dialogUserMessage.component.html',
  styleUrls: ['dialogUserMessage.component.scss']
})
export class DialogUserMessageComponent {
  public message: string;

  constructor(private dialogRef: MatDialogRef<DialogUserMessageComponent>, private usrSvc: UserService) {
  }

  public cancel() {
    this.dialogRef.close();
  }

  public save() {
    this.usrSvc.setUserMessage(this.message).subscribe(
      (player) => this.dialogRef.close(player),
      (err) => alert(err)
    )
  }
}